(function () {
    "use strict";

    angular.module("app").component("cisCertificate", {
        templateUrl: "@/cis/cis-certificate.template.html",
        controller: ClearanceController,
        controllerAs: "vm",
        bindings: {
            certificate: "<",
            organisation: "<",
        }
    });

    ClearanceController.$inject = ["$rootScope", "habilDate",];
    function ClearanceController($rootScope, habilDate) {
        const vm = this;

        vm.CisLevels = $rootScope.codeFVMCISLevels;
        vm.ApprovalTypes = $rootScope.codeCisApprovalTypes;
        vm.VMTypes = $rootScope.codeVMTypes;

        vm.getStyle = getStyle;

        function getStyle() {
            const expirationDate = habilDate.GetDateOnly(vm.certificate.ValidUntil);
            const today = habilDate.GetDateOnly(new Date());

            const warningDate = habilDate.AddMonths(today, 12);

            if (expirationDate.valueOf() < today.valueOf())
                return "bg-danger";
            if (expirationDate.valueOf() < warningDate.valueOf())
                return "bg-warning";

            return "bg-success";
        }
    }
})();
